import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

import Button from '@/shared/components/button/Button'
import { Text } from '@/shared/components/typography'

export default function NotFound() {
  return (
    <div className="absolute left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="mb-9 flex w-full flex-1 flex-col items-center justify-center gap-3">
        <Text level="text1" color="text090" weight="bold">
          찾을 수 없는 페이지입니다.
        </Text>
        <Text level="text1" color="text090" weight="bold">
          다시 시도해 주세요.
        </Text>
        <Image
          src="/images/light_img_noID_large.svg"
          alt="에러페이지"
          width={0}
          height={0}
          style={{ width: '70%', height: 'auto' }}
        />
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Link href="/" prefetch={false}>
          <Button text="홈으로 돌아가기" color="text010" background="bg030" disabled={false} />
        </Link>
      </div>
    </div>
  )
}
